export default __webpack_public_path__ + "static/media/slider-two.775c9814.png";